import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })

export default {
  // 获取组织架构树
  getOrganizationConfigTree(data) {
    return request({
      url: `/business/organization/config/tree`,
      method: 'GET',
      data
    })
  },
  // 根据子公司获取部门树
  getCompanyDepartmentTree(data) {
    return request({
      url: '/business/organization/companyDepartmentTree',
      method: 'POST',
      data
    })
  },
  // 根据子公司获取部门树
  getCompanySubmitDepartmentTree(data) {
    return request({
      url: '/business/organization/submitProcess/companyDepartmentTree',
      method: 'POST',
      data
    })
  },
  // 获取本部门及下级部门树
  sameDepartmentTree(data) {
    return request({
      url: '/business/organization/sameDepartmentTree',
      method: 'POST',
      data
    })
  },
  // 添加部门
  addDepartment(data) {
    return request({
      url: `/business/organization/config/addDepartment`,
      method: 'POST',
      data
    })
  },
  // 编辑部门
  editDepartment(data) {
    return request({
      url: `/business/organization/config/modifyDepartment`,
      method: 'POST',
      data
    })
  },
  // 删除部门
  delDepartment(data) {
    return request({
      url: `/business/organization/config/deleteDepartment`,
      method: 'POST',
      data
    })
  },
  // 导出数据
  exportAccountList(data) {
    return request({
      url: `/business/account/export`,
      method: 'POST',
      data
    })
  },
  // 权限范围内的组织架构
  getOrganizationTree(data) {
    return request({
      url: `/business/permission/organizationTree`,
      method: 'POST',
      data
    })
  }

}
